export const RESET_TOTAL_MONEY = "RESET_TOTAL_MONEY";
export const SET_TOTAL_MONEY = "CALCULATE_TOTAL_MONEY";
export const RESET_TOTAL_TIME = "RESET_TOTAL_TIME";
export const SET_TOTAL_TIME = "CALCULATE_TOTAL_TIME";
export const SET_CHOOSEN_ITEMS = "SET_CHOOSEN_ITEMS";
export const SET_MASTER = "SET_MASTER";
export const SET_MASTER_LIST = "SET_MASTER_LIST";
export const AUTH_SUCCES = "AUTH_SUCCES";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const PHONES_SET = "PHONES_SET";
export const MODAL_SET = "MODAL_SET";
export const SET_MODAL_CONTENT = "SET_MODAL_CONTENT";
